/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


   document.addEventListener('DOMContentLoaded', function() {
  const menuButtons = document.querySelectorAll('.sliderow');
  menuButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetMenu = document.getElementById(this.getAttribute('data-sliderule-open'));
      if (targetMenu) {
        targetMenu.classList.toggle('open');
      }
    });
  });

  const backButtons = document.querySelectorAll('.sliderow__back-button');
  backButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetMenu = document.getElementById(this.getAttribute('data-sliderule-close'));
      if (targetMenu) {
        targetMenu.classList.remove('open');
      }
    });
  });
});




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
